import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Auto-update PWA: registers /service-worker.js (production only),
// auto-activates new versions, and reloads the page on controllerchange
// so users never have to clear cache or reinstall the PWA.
registerServiceWorker();
